import { restClient } from '@/Core'

export const ChangeAssignmentStatusTask = async (taskUuid: string, status: string): Promise<void> => {
    await restClient.post(`/services/executor-assignments/${taskUuid}/change-status`, { json: { status } })
}
